import { callExternalApi } from "../../../services/external-api.service";
import { ITouchpoint } from "../../../../types/database/Touchpoint";

class AdvisorTouchpointHttpClient {
    _apiServerUrl;

    constructor(apiServerUrl = process.env.REACT_APP_API_ORIGIN) {
        this._apiServerUrl = `${apiServerUrl}/v2`;
    }

    async getAdvisorTouchpoints(projectTag: string, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/advisor/touchpoints`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data?.data || null,
            error,
        };
    }

    async getAdvisorTouchpoint(projectTag: string, touchpointUuid: string, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/advisor/touchpoint/${touchpointUuid}`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data?.data || null,
            error,
        };
    }

    async getProjectTouchpoints(projectTag: string, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/touchpoints`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data?.data || null,
            error,
        };
    }

    async getProjectTouchpoint(projectTag: string, touchpointUuid: string, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/touchpoint/${touchpointUuid}`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data?.data || null,
            error,
        };
    }
}

export default AdvisorTouchpointHttpClient;
